import type { Promoted } from '@/types';

/**
 * Represents the structure of a promoted object received from the backend API.
 */
export interface promotedDTO {
  element_id: number;
  element_type: string;
}

/**
 * Transforms a promotedDTO object into a Promoted object used in the frontend.
 * @param dto - The promotedDTO object received from the backend.
 * @returns The transformed Promoted object.
 */
export function mapDtoToPromoted(dto: promotedDTO): Promoted {

  const validTypes = ['category', 'event'] as const;
  if (!validTypes.includes(dto.element_type as any)) {
    console.warn(`promotedDTO invalid element_type: ${dto.element_type}. Expected 'category' or 'event'.`);
  }
  return {
    ...dto,
    element_type: dto.element_type as 'category' | 'event',
  };
}

/**
 * Transforms an array of promotedDTO objects into an array of Promoted objects.
 * @param dtos - The array of promotedDTO objects received from the backend.
 * @returns The transformed array of Promoted objects.
 */
export function mapDtosToPromoted(dtos: promotedDTO[]): Promoted[] {
  return dtos.map(mapDtoToPromoted);
}